/**
 * This file is used to provide functions that will generate primary filters
 *
 * As subcategories depend mainly on category we need to make sure to only
 * return the appropriate results
 */

import { editListingCategories } from '../../marketplace-custom-config';
import { getListingCategoriesFromURL, getListingSubCategoriesFromURL } from '../data';

export const generateSubCategoryFilter = (preference, category) => {
  if (!preference || !category) {
    return null;
  }

  // Get categories
  const preferences = editListingCategories.options;
  const categories = getListingCategoriesFromURL(preferences, preference);

  // Get subcategories
  const subCategories = getListingSubCategoriesFromURL(categories, category);

  // Generate the subcategory filter
  const subCategoryFilter = subCategories
    ? {
        id: 'subcategory',
        label: 'Sub category',
        type: 'SelectSingleFilter',
        group: 'primary',
        queryParamNames: ['pub_subcategory'],
        config: {
          options: subCategories,
        },
      }
    : null;

  return subCategoryFilter;
};
